import React from "react"
import styled from "styled-components"
import Container from "src/components/core/Container"
import { useStaticQuery, graphql } from "gatsby"
import Header from 'src/components/layout/header/header';
import Footer from 'src/components/layout/footer/footer';
import 'src/components/layout/resetcss.css';


const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledMain = styled.main`
  flex-grow: 1;
  min-height: 100vh;
  display: flex;
  position: relative;
  flex-direction: column;
  background-image: radial-gradient(circle, #f6fbeb, #d9e8e0, #c3d4d4, #b4bfc4, #a7aab0);
  background-image: radial-gradient(circle, #ecf6ff, #dbe2eb, #c9cfd7, #b8bcc3, #a7aab0);
`

const StyledContainer = styled(Container)`
    z-index: 1;
`

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query bgTexture {
      allFile(filter: { relativeDirectory: { eq: "textures/white" } }) {
        nodes {
          dir
          childImageSharp {
            fluid(maxWidth: 1600) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `)

  return (
    <StyledLayout>
      <Header/>
      <StyledMain>
      {/* <BackgroundTexture/> */}
        {/* <BackgroundImage
          Tag="section"
          fluid={data.allFile.nodes[2].childImageSharp.fluid}
          backgroundColor={`#040e18`}
        > */}
        <StyledContainer>

          {children}
        </StyledContainer>
        {/* </BackgroundImage> */}
      </StyledMain>
      <Footer/>
    </StyledLayout>
  )
}

export default Layout
